import classNames from "classnames";
import { FC, memo } from "react";

type PropTypes = {
  children: React.ReactNode;
  isActive?: boolean;
};

const Badge: FC<PropTypes> = ({ children, isActive = false }) => {
  return (
    <div className={classNames("badge", { "badge--active": isActive })}>
      <div className="badge__icon" />

      <span className="badge__content">{children}</span>
    </div>
  );
};

export default memo(Badge);
